// Dados jurídicos/LGPD — fonte única, reusada pelas 3 páginas legais e pelo
// banner de cookies. Coletados diretamente com o cliente em 2026-09-11.
//
// ⚠️ MODELO DE REFERÊNCIA — baseado em modelos comuns de mercado, não
// validado por advogado. Revisão jurídica obrigatória antes de publicar
// em produção, especialmente a base legal de cada tratamento e o texto
// de transferência internacional de dados.

import { COMPANY } from "@/data/constants";

export const LEGAL_ENTITY = {
  tradeName: COMPANY.full, // "M NAIEF Brindes Personalizados"
  legalName: "M NAIEF BRINDES PERSONALIZADOS",
  cnpj: "53.047.704/0001-86",
  address: COMPANY.address,
  city: COMPANY.city,
  state: COMPANY.state,
  // Não há encarregado de dados (DPO) com contato dedicado — o e-mail
  // comercial faz esse papel, por decisão do cliente.
  dpoContact: COMPANY.email,
};

export const HOSTING_INFO = {
  provider: "Hostinger",
  // Datacenter contratado pelo cliente fica na Lituânia (União Europeia) —
  // por isso a política precisa de uma seção de transferência internacional
  // (Art. 33 da LGPD).
  country: "Lituânia",
  region: "União Europeia",
};

/**
 * CRM usado para organizar/gerir os leads recebidos pelo site.
 * Confirmado pelo cliente em 2026-09-11. Desde 2026-09-16 há integração
 * técnica real: cada orçamento é encaminhado por webhook pro Biosfera,
 * com os dados de origem (UTM) — ver server/biosferaWebhook.js e
 * server/routes/leads.js.
 */
export const CRM_TOOL = {
  productName: "Biosfera",
  operatorTradeName: "Agência Lárbous",
  operatorLegalName: "LUIZ CLAUDIO TOBIAS SOBRAL",
  operatorCnpj: "12.363.317/0001-71",
};

/**
 * IDs de analytics/marketing — ainda NÃO implementados tecnicamente.
 * Confirmados pelo cliente: Google Analytics, Google Search Console,
 * Meta Pixel, Google Tag Manager. Troque os placeholders "TODO_..." pelos
 * IDs reais quando disponíveis — os loaders em lib/marketingScripts.js
 * não injetam nada enquanto o valor começar com "TODO_".
 */
export const MARKETING_IDS = {
  googleAnalyticsId: "TODO_GA_MEASUREMENT_ID", // formato G-XXXXXXXXXX
  googleTagManagerId: "TODO_GTM_CONTAINER_ID", // formato GTM-XXXXXXX
  metaPixelId: "TODO_META_PIXEL_ID", // só números
};

/** Categorias do banner de consentimento. "necessary" nunca é desativável. */
export const CONSENT_CATEGORIES = {
  necessary: {
    key: "necessary",
    label: "Necessários",
    description:
      "Essenciais para o site funcionar — inclui apenas o armazenamento local da sua escolha de cookies. Não podem ser desativados.",
  },
  analyticsMarketing: {
    key: "analyticsMarketing",
    label: "Analíticos e marketing",
    description:
      "Google Analytics, Google Tag Manager e Meta Pixel — nos ajudam a entender como o site é usado e medir o resultado de campanhas. Só carregam com o seu consentimento.",
  },
};

/**
 * Tabela exibida em /politica-de-cookies — reflete o que o site usa DE
 * FATO hoje (nenhuma ferramenta de analytics/marketing está tecnicamente
 * ativa ainda; listadas porque já foram confirmadas e o carregamento já
 * está preparado, condicionado ao consentimento — ver lib/marketingScripts.js).
 */
export const COOKIES_TABLE = [
  {
    category: "necessary",
    name: "mn_cookie_consent",
    type: "Armazenamento local (localStorage) — não é um cookie HTTP",
    provider: LEGAL_ENTITY.tradeName,
    purpose: "Guarda sua escolha de preferências de cookies, para não perguntar de novo a cada visita.",
    duration: "Até você mudar a preferência ou limpar os dados do navegador",
  },
  {
    category: "analyticsMarketing",
    name: "_ga, _ga_<ID do container>",
    type: "Cookie",
    provider: "Google Analytics",
    purpose: "Estatísticas de uso do site (páginas vistas, origem do tráfego) — ainda não ativado (ver nota acima).",
    duration: "Até 2 anos",
  },
  {
    category: "analyticsMarketing",
    name: "_fbp",
    type: "Cookie",
    provider: "Meta Pixel (Facebook/Instagram)",
    purpose: "Mede a eficácia de anúncios no Meta (Facebook/Instagram) — ainda não ativado (ver nota acima).",
    duration: "90 dias",
  },
  {
    category: "analyticsMarketing",
    name: "—",
    type: "Sem cookie próprio",
    provider: "Google Tag Manager",
    purpose: "Gerencia o carregamento de outras tags (como o Analytics) — não grava cookie por conta própria.",
    duration: "—",
  },
];

/** Recursos de terceiros carregados pelo site que não são cookies de rastreio. */
export const THIRD_PARTY_RESOURCES = [
  {
    name: "Google Fonts",
    domains: "fonts.googleapis.com, fonts.gstatic.com",
    note: "Carrega as fontes do site. Não grava cookie de rastreamento, mas a requisição chega aos servidores do Google (IP, user-agent).",
  },
  {
    name: "Font Awesome (via Cloudflare)",
    domains: "cdnjs.cloudflare.com",
    note: "Carrega os ícones do site. Mesma observação acima, para os servidores da Cloudflare.",
  },
  {
    name: "Google Search Console",
    domains: "—",
    note: "Usado apenas para confirmar a propriedade do site (uma tag de verificação). Não rastreia visitantes nem grava cookie.",
  },
];
